import React from 'react';
import Media from 'react-media';
import Helmet from 'react-helmet';

import Logo from 'components/Logo';

import FourHundredFour from 'assets/404-desktop.png';
import FourHundredFourMobile from 'assets/404-mobile.png';

import { Container, Text } from './style';

const NotFound = () => (
  <Container>
    <Helmet>
      <title>404 | Devfolio</title>
    </Helmet>
    <Logo style={{ marginBottom: 16 }} />
    <Media
      query="(max-width: 767px)"
      render={() => (
        <React.Fragment>
          <Text>
            <a href="/">Go home</a>
          </Text>
          <img src={FourHundredFourMobile} alt="Page Not Found" style={{ width: '96vw', padding: '36px 0' }} />
          <Text>The page you are looking for doesn&apos;t exist.</Text>
        </React.Fragment>
      )}
    />
    <Media
      query="(min-width: 768px)"
      render={() => (
        <React.Fragment>
          <Text>
            No, no, no nothing&apos;s here, <a href="/">let&apos;s go home</a>
          </Text>
          <div style={{ maxWidth: 600, padding: 48 }}>
            <img src={FourHundredFour} alt="Page Not Found" style={{ width: '100%', height: 'auto' }} />
          </div>
        </React.Fragment>
      )}
    />
  </Container>
);

export default NotFound;
